// Verifica una nómina de pago (Honorarios / Honorarios Adelanto) contra la última
// exportación anterior del mismo tipo, para alertar sobre auxiliares nuevos o con
// cambio de datos de pago antes de generar el Excel. No bloquea la exportación:
// si la verificación falla (red, backend caído, etc.) simplemente no se muestra alerta.
// La primera vez que se exporta un tipo de nómina no hay nada contra qué comparar,
// así que el backend no reporta "nuevos" ni "cambios" en ese caso.

export const verificarNominaPago = async (axiosInstance, periodo, tipo, items) => {
    try {
        const { data } = await axiosInstance.post("/liquidacion/nomina/verificar", {
            periodo,
            tipo,
            items,
        });
        if (data?.error) return null;
        return data?.data || null;
    } catch (error) {
        console.error("Error al verificar nómina de pago:", error);
        return null;
    }
};

/**
 * true si hay algo que mostrar en el modal de novedades (nuevos y/o cambios de datos
 * de pago). El modal (NominaCambiosModal) se muestra desde la vista solo cuando esto
 * es true.
 */
export const hayNovedadesNomina = (resultado) => {
    if (!resultado) return false;
    return (resultado.nuevos?.length || 0) > 0 || (resultado.cambios?.length || 0) > 0;
};

/**
 * Mapa auxiliar_id -> texto de alerta ("NUEVO EN NOMINA" / "CAMBIO CUENTA (...)"),
 * para anotar la columna "ALERTA DATOS" de cada fila del Excel exportado.
 */
export const construirAlertasPorAuxiliar = (resultado) => {
    const mapa = new Map();
    if (!resultado) return mapa;

    (resultado.nuevos || []).forEach(n => {
        mapa.set(n.auxiliar_id, "NUEVO EN NOMINA");
    });

    (resultado.cambios || []).forEach(c => {
        const detalle = (c.diferencias || [])
            .map(d => `${d.campo} antes: ${d.anterior || "-"}`)
            .join(", ");
        mapa.set(c.auxiliar_id, `CAMBIO DATOS PAGO (${detalle})`);
    });

    return mapa;
};

/**
 * Combina el texto de "ALERTA DATOS" ya calculado (FALTA BANCO/CUENTA/RUT) con la
 * novedad de nómina detectada, manteniendo el prefijo "REVISAR:" único por fila.
 */
export const mergeAlertaDatos = (alertaActual, alertaNomina) => {
    if (!alertaNomina) return alertaActual;
    if (!alertaActual) return `REVISAR: ${alertaNomina}`;
    return `${alertaActual}, ${alertaNomina}`;
};
